import { PaccSelfReportResultDto, PaccSelfReportResultRs } from '@domain/rs/phs/pacc/results/PaccSelfReportResultRs';
import { SelfReportType } from '@domain/constant/selfReportType';

export class SelfReportResultVO {
  type: SelfReportType;
  unreliableYn: boolean;

  constructor(rs: PaccSelfReportResultDto) {
    this.type = rs.type;
    this.unreliableYn = rs.unreliableYn;
  }
}

export class PaccSelfReportResultVO {
  results: SelfReportResultVO[] | null;

  constructor(rs: PaccSelfReportResultRs) {
    this.results = rs.results?.map((result) => new SelfReportResultVO(result));
  }
}
